import React, { useState, useEffect } from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { invoiceStatusList } from "../common/statusLists"; 

const InvoiceStatusSelect = ({ selectedStatus, onStatusChange }) => {
  const [invoiceStatus, setInvoiceStatus] = useState("");

  // Initialize with selectedStatus or the first option as default
  useEffect(() => {
    if (selectedStatus) {
      setInvoiceStatus(selectedStatus);
    } else if (invoiceStatusList.length > 0) {
      setInvoiceStatus(invoiceStatusList[0]);
    }
  }, [selectedStatus]);

  // Handle status change and pass the selected value to parent component
  const handleChange = (event) => {
    const newValue = event.target.value;
    setInvoiceStatus(newValue);
    onStatusChange(newValue); // Notify parent about the change
  };

  return (
    <FormControl variant="outlined" fullWidth size="small">
      <InputLabel>Status</InputLabel>
      <Select value={invoiceStatus} onChange={handleChange} label="Status">
        {invoiceStatusList.map((status) => (
          <MenuItem key={status} value={status}>
            {status}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default InvoiceStatusSelect;
